import { render, staticRenderFns } from "./recordPickingProducts.vue?vue&type=template&id=7d36704c&scoped=true"
import script from "./recordPickingProducts.vue?vue&type=script&lang=js"
export * from "./recordPickingProducts.vue?vue&type=script&lang=js"
import style0 from "./recordPickingProducts.vue?vue&type=style&index=0&id=7d36704c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36704c",
  null
  
)

export default component.exports